// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSSVariableValue } from '../../../assets/ts/_utils'
// import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

// type Props = {
//   className: string
//   chartColor: string
//   chartHeight: string
//   title: string
//   subtitle: string
//   amount: string
//   chartData?: { [key: string]: any } // Changed to any to handle mixed types
//   seriesName?: string // Optional series name
// }

// const MixedWidget102: React.FC<Props> = ({
//   className,
//   chartColor,
//   chartHeight,
//   title,
//   subtitle,
//   amount,
//   chartData,
//   seriesName = 'Quantity'
// }) => {
//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const { mode } = useThemeMode()

//   // Process chart data
//   const processedChartData = React.useMemo(() => {
//     if (!chartData) {
//       return {
//         categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
//         data: [15, 25, 15, 40, 20, 50]
//       }
//     }

//     const entries = Object.entries(chartData)

//     // Process categories (dates)
//     const categories = entries.map(([key]) => {
//       const date = new Date(key) // Use the date directly without adding '-01'
//       return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) // Show "Jun 8" format
//     })

//     // Process data values
//     const data = entries.map(([, value]) => {
//       // Clean up the value - extract the number part before "JS:"
//       let cleanValue: number = 0;

//       if (typeof value === 'string') {
//         if (value.includes('JS:')) {
//           const numPart = value.split('JS:')[0];
//           cleanValue = parseFloat(numPart) || 0;
//         } else {
//           cleanValue = parseFloat(value) || 0;
//         }
//       } else if (typeof value === 'number') {
//         cleanValue = value;
//       }

//       return Math.round(cleanValue * 100) / 100; // Round to 2 decimals
//     })

//     return { categories, data }
//   }, [chartData])

//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const chart = new ApexCharts(
//       chartRef.current,
//       chartOptions(chartColor, chartHeight, processedChartData, seriesName)
//     )
//     if (chart) {
//       chart.render()
//     }

//     return chart
//   }

//   useEffect(() => {
//     const chart = refreshChart()

//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [chartRef, mode, processedChartData])

//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Body */}
//       <div className='card-body d-flex flex-column p-0'>
//         {/* begin::Stats */}
//         <div className='flex-grow-1 card-p pb-0'>
//           <div className='d-flex flex-stack flex-wrap'>
//             <div className='me-2'>
//               <a href='#' className='text-dark text-hover-primary fw-bold fs-3'>
//                 {title}
//               </a>
//               <div className='text-dark fs-7 fw-semibold'>{subtitle}</div>
//             </div>
//             <div className={`fw-bold fs-2 text-${chartColor}`}>{amount}</div>
//           </div>
//         </div>
//         {/* end::Stats */}

//         {/* begin::Chart */}
//         <div ref={chartRef} className='mixed-widget-7-chart card-rounded-bottom'></div>
//         {/* end::Chart */}
//       </div>
//       {/* end::Body */}
//     </div>
//   )
// }

// const chartOptions = (
//   chartColor: string,
//   chartHeight: string,
//   processedData: { categories: string[], data: number[] },
//   seriesName: string
// ): ApexOptions => {
//   const labelColor = getCSSVariableValue('--bs-gray-800')
//   const strokeColor = getCSSVariableValue('--bs-gray-300')
//   const baseColor = getCSSVariableValue('--bs-' + chartColor)
//   const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')

//   // Calculate max value for y-axis
//   const maxValue = Math.max(...processedData.data)
//   const yAxisMax = Math.ceil(maxValue * 1.1) // Add 10% padding

//   return {
//     series: [
//       {
//         name: seriesName,
//         data: processedData.data,
//       },
//     ],
//     chart: {
//       fontFamily: 'inherit',
//       type: 'area',
//       height: chartHeight,
//       toolbar: {
//         show: false,
//       },
//       zoom: {
//         enabled: false,
//       },
//       sparkline: {
//         enabled: true,
//       },
//     },
//     plotOptions: {},
//     legend: {
//       show: false,
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     fill: {
//       type: 'solid',
//       opacity: 1,
//     },
//     stroke: {
//       curve: 'smooth',
//       show: true,
//       width: 3,
//       colors: [baseColor],
//     },
//     xaxis: {
//       categories: processedData.categories,
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//       labels: {
//         show: false,
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//       crosshairs: {
//         show: false,
//         position: 'front',
//         stroke: {
//           color: strokeColor,
//           width: 1,
//           dashArray: 3,
//         },
//       },
//       tooltip: {
//         enabled: false,
//       },
//     },
//     yaxis: {
//       min: 0,
//       max: yAxisMax,
//       labels: {
//         show: false,
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//     },
//     states: {
//       normal: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       hover: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       active: {
//         allowMultipleDataPointsSelection: false,
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//     },
//     tooltip: {
//       style: {
//         fontSize: '12px',
//       },
//       y: {
//         formatter: function (val) {
//           return val.toLocaleString()
//         },
//       },
//     },
//     colors: [lightColor],
//     markers: {
//       colors: [lightColor],
//       strokeColors: [baseColor],
//       strokeWidth: 3,
//     },
//   }
// }

// export { MixedWidget102 }




import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
  chartColor: string
  chartHeight: string
  title: string
  subtitle: string
  amount: string
  chartData?: { [key: string]: any }
  seriesName?: string
  color?: string
}

const MixedWidget102: React.FC<Props> = ({
  color,
  className,
  chartColor,
  chartHeight,
  title,
  subtitle,
  amount,
  chartData,
  seriesName = 'Quantity'
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const processedChartData = React.useMemo(() => {
    if (!chartData) {
      return {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        data: [15, 25, 15, 40, 20, 50]
      }
    }

    const entries = Object.entries(chartData)

    const categories = entries.map(([key]) => {
      const date = new Date(key)
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    })

    const data = entries.map(([, value]) => {
      let cleanValue: number = 0;

      if (typeof value === 'string') {
        if (value.includes('JS:')) {
          const numPart = value.split('JS:')[0];
          cleanValue = parseFloat(numPart) || 0;
        } else {
          cleanValue = parseFloat(value) || 0;
        }
      } else if (typeof value === 'number') {
        cleanValue = value;
      }

      return Math.round(cleanValue * 100) / 100;
    })

    return { categories, data }
  }, [chartData])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(
      chartRef.current,
      chartOptions(chartColor, chartHeight, processedChartData, seriesName, color)  // ✅ pass color
    )
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode, processedChartData, color])

  return (
    <div className={`card ${className}`}>
      <div className='card-body d-flex flex-column p-0'>
        <div className='flex-grow-1 card-p pb-0'>
          <div className='d-flex flex-stack flex-wrap'>
            <div className='me-2'>
              <a href='#' className='text-dark text-hover-primary fw-bold fs-3'>
                {title}
              </a>
              <div className='text-dark fs-7 fw-semibold'>{subtitle}</div>
            </div>
            {/* ✅ Remove Bootstrap text class when custom color is passed */}
            <div
              className={`fw-bold fs-2 ${color ? '' : `text-${chartColor}`}`}
              style={{ color: color || undefined }}
            >
              {amount}
            </div>
          </div>
        </div>
        <div ref={chartRef} className='mixed-widget-7-chart card-rounded-bottom'></div>
      </div>
    </div>
  )
}

const chartOptions = (
  chartColor: string,
  chartHeight: string,
  processedData: { categories: string[], data: number[] },
  seriesName: string,
  color?: string  // ✅ add color param
): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-800')
  const strokeColor = getCSSVariableValue('--bs-gray-300')

  // ✅ Use custom color if passed, otherwise fallback to chartColor
  const baseColor = color || getCSSVariableValue('--bs-' + chartColor)
  const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')

  const maxValue = Math.max(...processedData.data)
  const yAxisMax = Math.ceil(maxValue * 1.1)

  return {
    series: [
      {
        name: seriesName,
        data: processedData.data,
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: chartHeight,
      toolbar: { show: false },
      zoom: { enabled: false },
      sparkline: { enabled: true },
    },
    plotOptions: {},
    legend: { show: false },
    dataLabels: { enabled: false },
    fill: {
      type: 'solid',
      opacity: 1,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [baseColor],  // ✅ graph line color
    },
    xaxis: {
      categories: processedData.categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        show: false,
        style: { colors: labelColor, fontSize: '12px' },
      },
      crosshairs: {
        show: false,
        position: 'front',
        stroke: { color: strokeColor, width: 1, dashArray: 3 },
      },
      tooltip: { enabled: false },
    },
    yaxis: {
      min: 0,
      max: yAxisMax,
      labels: {
        show: false,
        style: { colors: labelColor, fontSize: '12px' },
      },
    },
    states: {
      normal: { filter: { type: 'none', value: 0 } },
      hover: { filter: { type: 'none', value: 0 } },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: { type: 'none', value: 0 },
      },
    },
    tooltip: {
      style: { fontSize: '12px' },
      y: {
        formatter: function (val) {
          return val.toLocaleString()
        },
      },
    },
    colors: [lightColor],
    markers: {
      colors: [lightColor],
      strokeColors: [baseColor],  // ✅ marker stroke color
      strokeWidth: 3,
    },
  }
}

export { MixedWidget102 }